import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import './polyfills/fromEntries';
import "./polyfills/randomUUID";

import React from "react";
import ReactDOM from "react-dom/client";

import './index.css';
import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';

import logo_pipal from './assets/img/logo_pipal.png'
import logo_footer from './assets/img/logo_footer.png'

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

// Limpieza de service workers obsoletos
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg.unregister());
  });
  caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
}

const msalInstance = new PublicClientApplication(msalConfig);

const recargar = () => {
  window.location.reload();
}

const root = ReactDOM.createRoot(document.getElementById("root"));

// Inicialización asíncrona de MSAL y manejo del redirect promise antes de renderizar
msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise().then((tokenResponse) => {
    if (tokenResponse && tokenResponse.account) {
      msalInstance.setActiveAccount(tokenResponse.account);
    }
  }).catch((err) => {
    console.warn("⚠️ Error menor en handleRedirectPromise:", err);
  });
}).then(() => {
  console.log("🚀 [MSAL] Inicializado correctamente. Montando aplicación...");

  root.render(
    <div>
      <nav className="navbar navbar-light piePagina">
        <div className="container-fluid">
          <div className="col-12 d-flex justify-content-left align-items-center">
            <img
              src={logo_pipal}
              className="brand-logo mt-2"
              onClick={recargar}
              alt="Logo"
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
      </nav>

      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>

      <nav>
        <div id="contFooter" className="row">
          <div className="navbar navbar-light text-muted mt-auto">
            <div className="col-12 d-flex justify-content-center">
              <img className="brand_banner" src={logo_footer} alt="Ministerio banner" />
            </div>
            <div className="col-12 col-md-12 d-flex justify-content-center mt-2">
              Contacto: <a href="https://educacioncba.edu.ar">educacioncba.edu.ar</a>
            </div>
            <div className="col-12 col-md-12 text-center">
              © 2024 Ministerio de Educación de la Prov. de Córdoba — Subdirección de Infraestructura Tecnológica y Conectividad
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}).catch((error) => {
  console.error("❌ Error crítico al inicializar MSAL:", error);
});